import React from 'react';
import GlyphAtom from '../Glyph/GlyphAtom';
import './ItemTypeGlyphAtom.scss';

export type MarketplaceItemType =
  | 'approach'
  | 'video'
  | 'metric_library'
  | 'evaluation'
  | 'assistant'
  | 'form'
  | 'schema'
  | 'context'
  | 'arc_template'
  | 'orbit_template'
  | 'metaspace'
  | 'aspect'
  | 'aspect_group'
  | 'composition';

export interface ItemTypeGlyphAtomProps {
  type: MarketplaceItemType;
  size?: number;
  ariaLabel?: string;
  className?: string;
}

import { MARKETPLACE_ITEM_TYPE_ICONS } from './iconMaps';

const ITEM_TYPE_ICON_MAP = MARKETPLACE_ITEM_TYPE_ICONS;

const ItemTypeGlyphAtom: React.FC<ItemTypeGlyphAtomProps> = ({
  type,
  size,
  ariaLabel,
  className = '',
}) => {
  const classes = [
    'marketplace-item-type-glyph',
    `marketplace-item-type-glyph--${type}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const style = size ? { width: `${size}px`, height: `${size}px` } : undefined;

  return (
    <span
      className={classes}
      style={style}
      role={ariaLabel ? 'img' : undefined}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
    >
      <GlyphAtom
        glyph={ITEM_TYPE_ICON_MAP[type]}
        className="marketplace-item-type-glyph__icon"
      />
    </span>
  );
};

ItemTypeGlyphAtom.displayName = 'ItemTypeGlyphAtom';

export default ItemTypeGlyphAtom;
